module.exports = __webpack_public_path__ + "img/intro-1.72ecab55.png";